import { Modal } from '@components/modal';
import { useCreateDemoAccount } from 'api/sysadmin/sysAdminServices';
import useHRForm from 'hooks/useHRForm';
import { type Disclosure } from 'interfaces/disclosure/Disclosure.interface';
import { type FC, useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { ManageDemoAccountForm } from '../../form';
import { demoAccountSchema } from '../../form/schema';

interface CreateDemoAccountModalProps extends Disclosure {}

const CreateDemoAccountModal: FC<CreateDemoAccountModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const { methods } = useHRForm({ schema: demoAccountSchema });
  const { mutate, isPending, isSuccess } = useCreateDemoAccount();

  const handleCreateDemoAccount = (): void => {
    const body = methods.getValues();
    mutate(body);
  };

  useEffect(() => {
    if (isOpen) {
      methods.reset();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      actionBtns={{
        primary: {
          label: 'Create Demo account',
          onClick: methods.handleSubmit(handleCreateDemoAccount),
          isLoading: isPending,
        },
        secondary: { label: 'Cancel' },
      }}
      maxWidth={500}
      title={'Create new Demo account'}
    >
      <FormProvider {...methods}>
        <ManageDemoAccountForm />
      </FormProvider>
    </Modal>
  );
};
export default CreateDemoAccountModal;
